import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBucket: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"bucket, trash, can"} maskId="square-filled-radius-0-stroke-1-IconBucket"><path d="M2 3V8H22V3H2Z" fill="currentColor"/><path d="M3.7964 9L5.04949 21H18.9505L20.2037 9H3.7964Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconBucket;
